<template lang="pug">
	figure.tiptap-figure
		button.frame(
			type="button",
			:aria-label="zoomLabel",
			:class="{ loading: !loaded }",
			:style="frameStyle",
			@click="zoom"
		)
			img(
				:src="src",
				:alt="alt",
				:title="title",
				:width="width",
				:height="height",
				loading="lazy",
				decoding="async",
				@load="loaded = true",
				@error="loaded = true"
			)
		figcaption(v-if="caption") {{ caption }}
</template>

<script>
export default {
	name: 'component-tiptap-figure',
	props: {
		src: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			default: '',
		},
		caption: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: null,
		},
		width: {
			type: Number,
			default: null,
		},
		height: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			loaded: false,
		}
	},
	computed: {
		// Enquanto carrega, a caixa usa a proporção real quando o admin informa as medidas (16:9 é só o padrão)
		frameStyle() {
			if (this.loaded || !this.width || !this.height)
				return null
			return { aspectRatio: `${this.width} / ${this.height}` }
		},
		zoomLabel() {
			return this.alt ? `Ampliar imagem: ${this.alt}` : 'Ampliar imagem'
		},
	},
	watch: {
		// Outra imagem no mesmo componente: o esqueleto volta
		src() {
			this.loaded = false
		},
	},
	methods: {
		// Toda imagem amplia (o `zoomable` do documento é ignorado); mesmo modal do bloco `imagemodal` legado
		zoom() {
			this.$store.commit('setImage', { ativo: true, content: { image: this.src, alt: this.alt, text: '', caption: this.caption } })
		},
	},
}
</script>

<style lang="stylus" scoped src="./Figure.styl"></style>
